import variationsFor from './variationsFor'

const types = {
  ...variationsFor('GET_ACCOUNTS')
}

export default types
